//
import CostCenterModel from '@/models/Accounting/AccCostCenter'
import PaymentConditionModel from '@/models/Purchase/PchPaymentCondition'
import ProviderModel from '@/models/Purchase/PchProvider'
import ProviderBranchOfficeModel from '@/models/Purchase/PchProviderBranchOffices'
import WhProductModel from '@/models/Warehouse/WhProduct'

//
import PchDetailPurchaseInvoiceHeaders from '@/views/Purchase/PchPurchaseInvoice/create/headers'
import WhProductPickerHeaders from '@/views/Warehouse/WhProduct/picker/headers'

//
export default [
  {
    name: 'pch_provider_id',
    type: 'autocomplete-model',
    props: {
      label: 'Proveedor',
      itemText: 'business_name',
      itemValue: 'id',
      model: ProviderModel,
      noObject: true,
    },
    trigger: provider_trigger,
  },
  {
    name: 'pch_provider_branch_offices_id',
    type: 'autocomplete',
    props: {
      clearable: true,
      itemText: 'address',
      itemValue: 'id',
      label: 'Sucursal',
      noDataText: 'Sin sucursales',
      items: [],
      noObject: true,
    },
  },
  {
    name: 'invoice_number',
    type: 'text-field',
    props: {
      label: 'N° de factura',
    },
  },
  {
    name: 'pch_payment_condition_id',
    type: 'autocomplete-model',
    props: {
      label: 'Método de pago',
      itemText: 'type',
      itemValue: 'id',
      model: PaymentConditionModel,
      noObject: true,
      paramSearch: 'type',
    },
  },
  {
    name: 'emission_date',
    type: 'date-field',
    props: {
      label: 'Fecha emisión',
    },
  },
  {
    name: 'payment_date',
    type: 'date-field',
    props: {
      label: 'Fecha pago',
    },
  },
  {
    name: 'selected',
    type: 'table-field',
    flex: {
      'd-grid': true,
      'pt-0': true,
      xs12: true,
    },
    props: {
      headers: PchDetailPurchaseInvoiceHeaders,
      noDataText: 'Sin productos.',
      noExport: true,
      noRefresh: true,
      showNativePagination: true,
      toolbarTitle: 'Lista de productos',
    },
  },
  {
    name: 'extra_tax',
    type: 'currency-field',
    props: {
      label: 'Impuesto extra',
      reverse: true,
    },
  },
  {
    name: 'selected_net_total',
    type: 'currency-field',
    props: {
      label: 'Neto',
      readonly: true,
      reverse: true,
    },
  },
  {
    name: 'selected_iva',
    type: 'currency-field',
    props: {
      label: 'IVA',
      readonly: true,
      reverse: true,
    },
  },
  {
    name: 'selected_total',
    type: 'currency-field',
    props: {
      label: 'Total',
      readonly: true,
      reverse: true,
    },
  },
  {
    name: 'acc_cost_center_id',
    type: 'autocomplete-model',
    props: {
      label: 'Centro costo',
      itemText: 'name',
      itemValue: 'id',
      model: CostCenterModel,
      noDataText: 'No se encontraron centros de costo.',
      noObject: true,
      paramSearch: 'name',
    },
  },
  {
    name: 'is_exent',
    type: 'checkbox',
    props: {
      label: 'Factura exenta',
    },
  },
  {
    name: 'payable',
    type: 'checkbox',
    props: {
      falseValue: true,
      label: 'Bloquear pago',
      trueValue: false,
    },
  },
]

/**
 * Provider Trigger
 * @param {*} ctx 
 */
function provider_trigger(ctx) {
  ctx.getField('pch_provider_branch_offices_id').props.items = ctx.getInput('pch_provider_id').getSelected().branch_offices
  ctx.getFieldset().$forceUpdate()
}
